module.exports = __webpack_public_path__ + "jsoneditor-icons.svg";


//////////////////
// WEBPACK FOOTER
// ./~/jsoneditor/dist/img/jsoneditor-icons.svg
// module id = 103
// module chunks = 67